import { getMemberId } from '@trello/authentication';
import { PersistentSharedState } from '@trello/shared-state';

export const splitScreenOnboardingDismissalState = new PersistentSharedState<{
  timestamp?: number;
}>(
  {},
  {
    storageKey: () =>
      `splitScreenOnboardingMessageDismissal-${getMemberId() || 'anonymous'}`,
  },
);
